module.exports = __webpack_public_path__ + "img/act_icon_all.c8f3bef.png";